import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ArrowLeftOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { Modal, Avatar, Space, Input, Button, Select, Upload, message, Typography, Table, Popconfirm, Spin, InputNumber, DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'
import axios from 'axios'

const styleVideo = {
  width: 300,
  height: 'auto',
  objectFit: 'cover',
  marginRight: '10px',
}

function CreateStack() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const organization = searchParams.get('organization')
  const id = searchParams.get('id')
  const stackId = searchParams.get('stackId')

  const auth = useSelector((state) => state.auth)
  const [focusItems, setFocusItems] = useState([])
  const [removedVideoNames, setRemovedVideoNames] = useState([]) // useable only during edit
  const [loading, setLoading] = useState(false)
  const [theStack, setTheStack] = useState(null)
  const [form, setForm] = useState({
    stackTitle: '',
    levels: [],
  })

  // Text input field
  const onChange = (obj) => {
    // console.log(obj)
    setForm((prev) => ({ ...prev, ...obj }))
  }

  const handleAddNewLevel = () => {
    const nextLevelNumber = form.levels.length > 0 ? Math.max(...form.levels.map((l) => l.level)) + 1 : 1

    const newLevel = {
      level: nextLevelNumber,
      levelName: '',
      description: '',
      videos: [],
      mandatoryPriorities: [],
      optionalPriorities: [],
      mandatoryHabits: [],
      optionalHabits: [],
      mandatoryChallenges: [],
      optionalChallenges: [],
      mandatoryGoals: [],
      optionalGoals: [],
    }

    setForm((prev) => ({
      ...prev,
      levels: [...prev.levels, newLevel],
    }))

    // To show the Admin, where to put the data for new level
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    })
  }

  const onLevelDataChange = (obj) => {
    let theObj = obj
    console.log(JSON.stringify(theObj))
    setForm((prevForm) => {
      const updatedLevels = prevForm.levels.map((lvl) => {
        if (lvl.level === theObj.level) {
          const keys = Object.keys(theObj)
          const keysToUpdate = [
            'mandatoryGoals',
            'optionalGoals',
            'mandatoryChallenges',
            'optionalChallenges',
            'mandatoryHabits',
            'optionalHabits',
            'mandatoryPriorities',
            'optionalPriorities',
          ]

          if (keysToUpdate.includes(keys[1])) {
            const currentKey = keys[1]

            // map each goal id into the object format
            console.log(lvl[currentKey]) // E.g. mandatoryGoals array of object under this level

            let transformedGoals = []

            // If no mandatory goals selected for this level before, then for the new mandatory goals Ids, make object format (because they are brand new, so user never modified the attached other activities of this mandatory activities)
            if (lvl[currentKey].length == 0) {
              transformedGoals = theObj[currentKey].map((id) => {
                let theGoalItem = focusItems.filter((elem) => elem._id == id)
                theGoalItem = theGoalItem[0]

                return {
                  _id: id,
                  optionalChallenges: theGoalItem.optionalChallenges.map((ch) => ch._id),
                  mandatoryChallenges: theGoalItem.mandatoryChallenges.map((ch) => ch._id),
                  mandatoryHabits: theGoalItem.mandatoryHabits.map((ch) => ch._id),
                  optionalHabits: theGoalItem.optionalHabits.map((ch) => ch._id),
                  mandatoryPriorities: theGoalItem.habitsPriorities.map((ch) => ch._id),
                  optionalPriorities: theGoalItem.optionalPriorities.map((ch) => ch._id),
                }
              })
            } else {
              // If previously mandatory goals added inside this form
              const createAbleIds = theObj[currentKey].filter((id) => {
                const isThisAlreadyTransformed = lvl[currentKey].filter((elem) => {
                  if (id == elem._id) {
                    return true
                  } else {
                    return false
                  }
                })

                // If not found inside the array of objects previously
                if (isThisAlreadyTransformed.length == 0) {
                  return true
                } else {
                  return false
                }
              })

              // Now transform the new Ids into new array, to join with old array of objects
              transformedGoals = createAbleIds.map((id) => {
                let theGoalItem = focusItems.filter((elem) => elem._id == id)
                theGoalItem = theGoalItem[0]

                return {
                  _id: id,
                  optionalChallenges: theGoalItem.optionalChallenges.map((ch) => ch._id),
                  mandatoryChallenges: theGoalItem.mandatoryChallenges.map((ch) => ch._id),
                  mandatoryHabits: theGoalItem.mandatoryHabits.map((ch) => ch._id),
                  optionalHabits: theGoalItem.optionalHabits.map((ch) => ch._id),
                  mandatoryPriorities: theGoalItem.habitsPriorities.map((ch) => ch._id),
                  optionalPriorities: theGoalItem.optionalPriorities.map((ch) => ch._id),
                }
              })

              transformedGoals = [...lvl[currentKey], ...transformedGoals]

              // If any item is found at old objects, but not found at newly "theObj.mandatoryGoals", then consider it as user deleted that item, so remove it from sending at backend
              transformedGoals = transformedGoals.filter((elem) => {
                // Check each element in transformedGoals against theObj.mandatoryGoals
                const itemFound = theObj[currentKey].includes(elem._id)

                // If itemFound falsy that means item not found, so filter it out from "transformedGoals"
                if (!itemFound) {
                  return false
                } else {
                  return true
                }
              })
            }

            // console.log('transformedGoals')
            // console.log(transformedGoals)

            theObj = {
              ...theObj,
              [currentKey]: transformedGoals,
            }
          }
          return { ...lvl, ...theObj } // Merge existing level with new updates
        }
        return lvl
      })

      return {
        ...prevForm,
        levels: updatedLevels,
      }
    })
  }

  const onAssociatedDataChange = (obj) => {
    let theObj = obj
    console.log(`theObj below: `)
    console.log(theObj)
    setForm((prevForm) => {
      const keysToUpdate = [
        'mandatoryGoals',
        'optionalGoals',
        'mandatoryHabits',
        'optionalHabits',
        'mandatoryChallenges',
        'optionalChallenges',
        'mandatoryPriorities',
        'optionalPriorities',
      ]

      const updatedLevels = prevForm.levels.map((lvl) => {
        if (lvl.level == theObj.level) {
          // Check if theObj.key is one of the keys we want to modify
          if (keysToUpdate.includes(theObj.key)) {
            if (theObj.actionType === 'remove') {
              // E.g. arrays under that mandatoryGoal Object, like mandatoryPriorities for that particular mandatory goal
              const modifiedArray = lvl[theObj.key].map((elem) => {
                if (elem._id === theObj.keyId) {
                  const filteredArray = elem[theObj.type].filter(
                    (item) => item !== theObj.itemId // filter OUT the matching item
                  )
                  return {
                    ...elem,
                    [theObj.type]: filteredArray,
                  }
                }
                // leave other objects in lvl[theObj.key] array, unchanged
                return elem
              })

              return {
                ...lvl,
                [theObj.key]: modifiedArray,
              }
            } else if (theObj.actionType === 'add') {
              // Add logic
              const modifiedArray = lvl[theObj.key].map((elem) => {
                if (elem._id === theObj.keyId) {
                  // prevent duplicate before adding
                  const updatedArray = elem[theObj.type].includes(theObj.itemId) ? elem[theObj.type] : [...elem[theObj.type], theObj.itemId]

                  return {
                    ...elem,
                    [theObj.type]: updatedArray,
                  }
                }
                return elem // leave other objects in lvl[theObj.key] array, unchanged
              })

              return {
                ...lvl,
                [theObj.key]: modifiedArray,
              }
            }
          }
        }

        // if no condition matched, just return lvl unchanged
        return lvl
      })

      return {
        ...prevForm,
        levels: updatedLevels,
      }
    })
  }

  const RenderList = ({ title, dataCategory, data, onDelete }) => {
    if (!data || data.length === 0) return null

    return (
      <>
        <p style={{ fontStyle: 'italic' }}>{title}</p>
        <ul>
          {data.map((item, idx) => (
            <li
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                marginBottom: 4,
              }}
            >
              <span>
                {item.subTitle} <span style={{ color: '#c4c4c4' }}>{item.isMissing && '(Added extra)'}</span>
              </span>
              <DeleteOutlined
                style={{ color: 'red', cursor: 'pointer' }}
                onClick={() =>
                  onAssociatedDataChange({
                    itemId: item._id,
                    ...onDelete,
                    actionType: 'remove', // or 'add'
                  })
                }
              />
            </li>
          ))}
        </ul>

        <Select
          mode="multiple"
          optionFilterProp="label"
          placeholder={`Add more ${title}`}
          style={{
            width: `100%`,
          }}
          // onChange={(value) => {}} // No need
          onSelect={(value, option) => {
            // console.log(value) // The _id
            // console.log(option) // Entire option with label and value property
            onAssociatedDataChange({
              itemId: value,
              ...onDelete,
              actionType: 'add', // or 'remove'
            })
          }}
          options={focusItems
            .filter((el) => el.category == dataCategory)
            .map((el) => {
              return {
                label: el.subTitle,
                value: el._id,
              }
            })}
        />
      </>
    )
  }

  const getFocusAreas = async (v) => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/focus/getFocusAreaById?focusId=${id}`)
      const response2 = await axiosInstance.get(`/api/v1/focus/focusItems?organization=${organization}&sendDisabled=true`)

      // console.log(response.data.focusArea) // Focus area information like H&F and and full form
      // console.log(response2.data.focusItems)
      setFocusItems(response2.data.focusItems) // all focus items under this parent Focus area

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getTheStack = async () => {
    try {
      if (auth.user.organizations?.length) {
        setLoading(true)

        const response = await axiosInstance.get(`/api/v1/focusStacks/getAllStacks?focusAreaId=${id}&stackId=${stackId}`)

        if (response.data?.allStacks.length) {
          setTheStack(response.data?.allStacks[0])
          setForm(response.data?.allStacks[0])
        }

        setLoading(false)
      }
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const beforeUploadPictureUpload = (file) => {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'

    const isVideo =
      file.type === 'video/mp4' ||
      file.type === 'video/quicktime' || // .mov
      file.type === 'video/webm'

    if (!isImage && !isVideo) {
      message.error(`${file.name} is not a supported file type. Please upload JPEG, PNG, MP4, MOV, or WEBM.`)
      return Upload.LIST_IGNORE
    }

    const maxSizeMB = isImage ? 5 : 500
    const isWithinLimit = file.size / 1024 / 1024 < maxSizeMB

    if (!isWithinLimit) {
      message.error(`${file.name} must be smaller than ${maxSizeMB}MB!`)
      return Upload.LIST_IGNORE
    }

    // Prevent auto-upload, but still add to fileList
    return false
  }

  const createFocusStack = async (v) => {
    try {
      setLoading(true)

      if (!form.stackTitle) {
        alert("Title can't be empty!")
        setLoading(false)
        return
      }

      const fmData = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${auth.token}`,
        },
      }

      // Use for loop to allow early return
      for (let idx = 0; idx < form.levels?.length; idx++) {
        const el = form.levels[idx]

        // console.log(el?.videos)
        // console.log('el.videos[0]?.originFileObj')
        // console.log(el.videos[0]?.originFileObj)
        // console.log('Is file?', el.videos[0]?.originFileObj instanceof File)

        // ? Because client doesn't want attachment mandatory
        // if (!el.videos.length) {
        //   alert('Please add atleast one video to all level.')
        //   setLoading(false)
        //   return
        // }
      }

      form.levels?.forEach((el, idx) => {
        el.videos.forEach((videoObj, vidIdx) => {
          const theVideo = videoObj?.originFileObj

          if (!theVideo) return

          // theVideo.extraInfo = 'Test' // not working
          // Get original file name and extension
          const nameParts = theVideo.name.split('.')
          const originalNameWithoutExt = nameParts.slice(0, -1).join('.')
          const extension = nameParts.pop() // gets last part as extension

          // Build new file name
          const newFileName = `${originalNameWithoutExt}_video${vidIdx + 1}_${idx + 1}.${extension}` // example: _video2_1.mp4 // Here first video number and last number before extension is level number ( which is important at backend to store the video data to appropiate level )

          const renamedFile = new File(
            [theVideo], // file content (Blob or File)
            newFileName, // new filename
            {
              type: theVideo.type, // preserve MIME type
              lastModified: theVideo.lastModified,
            }
          )

          if (el.videos.length) {
            // ! Not working
            // fmData.append('videos', {
            //   // uri: result.assets[0].uri,
            //   // type: mime.getType(result.assets[0].uri),
            //   // name: result.assets[0].uri.split('/').pop(),
            //   ...el.videos[0]?.originFileObj,
            // })
            fmData.append('videos', renamedFile)
          }
        })
      })

      // return

      fmData.append('stackTitle', form.stackTitle)
      fmData.append('focusAreaId', id)
      fmData.append('levels', JSON.stringify(form.levels))

      // return

      const res = await axios
        .post(`${process.env.REACT_APP_BASE_URL}/api/v1/focusStacks/createNewStack`, fmData, config)
        .then((res) => {
          //   console.log(res.data)
          navigate(-1)
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
        })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const editFocusStack = async (v) => {
    try {
      setLoading(true)

      if (!form.stackTitle) {
        alert("Title can't be empty!")
        setLoading(false)
        return
      }

      const fmData = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${auth.token}`,
        },
      }

      // Use for loop to allow early return
      for (let idx = 0; idx < form.levels?.length; idx++) {
        const el = form.levels[idx]

        // console.log(el?.videos)
        // console.log('el.videos[0]?.originFileObj')
        // console.log(el.videos[0]?.originFileObj)
        // console.log('Is file?', el.videos[0]?.originFileObj instanceof File)

        // ? Because client doesn't want attachment mandatory
        // if (!el.videos.length) {
        //   alert('Please add atleast one video to all level.')
        //   setLoading(false)
        //   return
        // }
      }

      form.levels?.forEach((el, idx) => {
        el.videos.forEach((videoObj, vidIdx) => {
          const theVideo = videoObj?.originFileObj

          if (!theVideo) return

          // theVideo.extraInfo = 'Test' // not working
          // Get original file name and extension
          const nameParts = theVideo.name.split('.')
          const originalNameWithoutExt = nameParts.slice(0, -1).join('.')
          const extension = nameParts.pop() // gets last part as extension

          // Build new file name
          const newFileName = `${originalNameWithoutExt}_video${vidIdx + 1}_${idx + 1}.${extension}` // example: _video2_1.mp4 // Here first video number and last number before extension is level number ( which is important at backend to store the video data to appropiate level )

          const renamedFile = new File(
            [theVideo], // file content (Blob or File)
            newFileName, // new filename
            {
              type: theVideo.type, // preserve MIME type
              lastModified: theVideo.lastModified,
            }
          )

          if (el.videos.length) {
            // ! Not working
            // fmData.append('videos', {
            //   // uri: result.assets[0].uri,
            //   // type: mime.getType(result.assets[0].uri),
            //   // name: result.assets[0].uri.split('/').pop(),
            //   ...el.videos[0]?.originFileObj,
            // })
            fmData.append('videos', renamedFile)
          }
        })
      })

      // return

      fmData.append('stackTitle', form.stackTitle)
      fmData.append('focusAreaId', id)
      fmData.append('levels', JSON.stringify(form.levels))
      fmData.append('removedVideoNames', JSON.stringify(removedVideoNames))

      console.log(fmData)
      for (let pair of fmData.entries()) {
        console.log(`${pair[0]}:`, pair[1])
      }

      // return

      const res = await axios
        .put(`${process.env.REACT_APP_BASE_URL}/api/v1/focusStacks/editEntireStack?stackId=${stackId}`, fmData, config)
        .then((res) => {
          //   console.log(res.data)
          navigate(-1)
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
        })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  useEffect(() => {
    getFocusAreas()
  }, [])
  useEffect(() => {
    getTheStack()
  }, [stackId])

  useEffect(() => {
    // console.log(form)
  }, [form])

  return (
    <Layout>
      <ArrowLeftOutlined
        Video={{
          color: '#1677ff',
          fontSize: '1.5rem',
          marginBottom: 20,
          cursor: 'pointer',
        }}
        onClick={() => navigate(-1)}
      />
      {focusItems.length > 0 ? (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <div>{!stackId ? 'Create a new Stack' : 'Edit stack'}</div>
          {/* <p>{JSON.stringify(!!theStack)}</p> */}
          <Input placeholder="Enter the title" value={form.stackTitle} style={{ marginBottom: 10 }} onChange={(e) => onChange({ stackTitle: e.target.value })} />
          <Button onClick={() => handleAddNewLevel()}>Add new level</Button>

          {form.levels.map((el, idx) => {
            return (
              <div key={idx} style={{ marginTop: 20, border: '.5px solid grey', padding: 10 }}>
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                  <h1>Level {el.level}</h1>
                  <Input
                    placeholder="Enter customized level name here"
                    defaultValue={el.levelName}
                    value={form.levelName}
                    onChange={(e) => onLevelDataChange({ level: el.level, levelName: e.target.value })}
                  />
                  <Input.TextArea
                    placeholder="Description"
                    defaultValue={el.description}
                    value={form.description}
                    onChange={(e) => onLevelDataChange({ level: el.level, description: e.target.value })}
                  />
                  {/* // Only on edit mode, show video preview */}
                  {stackId && (
                    <>
                      <h3>Uploaded videos</h3>
                      <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0, flexWrap: 'wrap', gap: 10, border: '1px solid white' }}>
                        {el.videos.map((video, idx) => {
                          // console.log(video)
                          if (video.contentType?.split('/')[0] == 'video') {
                            return (
                              <div key={idx} style={{ border: '1px solid white', display: 'flex', flexDirection: 'column', gap: 4 }}>
                                <video style={styleVideo} src={video.mediaLink} controls />
                                <Button
                                  danger
                                  onClick={() => {
                                    const filteredVideoList = el.videos.filter((eachVideo) => eachVideo.name !== video.name)
                                    onLevelDataChange({ level: el.level, videos: filteredVideoList })
                                    setRemovedVideoNames((prev) => [...prev, video.name]) // to send at backend
                                  }}
                                >
                                  Delete video parmanently
                                </Button>
                              </div>
                            )
                          } else if (video.contentType?.split('/')[0] == 'image') {
                            return (
                              <div key={idx} style={{ border: '1px solid white', display: 'flex', flexDirection: 'column', gap: 4 }}>
                                <img src={video.mediaLink} alt="." style={{ width: 300, height: 300 }} />
                                <Button
                                  danger
                                  onClick={() => {
                                    const filteredVideoList = el.videos.filter((eachVideo) => eachVideo.name !== video.name)
                                    onLevelDataChange({ level: el.level, videos: filteredVideoList })
                                    setRemovedVideoNames((prev) => [...prev, video.name]) // to send at backend
                                  }}
                                >
                                  Delete video parmanently
                                </Button>
                              </div>
                            )
                          }
                        })}
                      </div>
                    </>
                  )}
                  <Upload.Dragger
                    // style={{ height: 100 }}
                    name="logo"
                    listType="picture"
                    maxCount={5}
                    // customRequest={uploadProfilePicture} // Don't use this function immediately after something gets selected
                    beforeUpload={beforeUploadPictureUpload}
                    onChange={({ fileList }) => {
                      const missingInVideo2 = el.videos.filter((v1) => !fileList.some((v2) => v2.name === v1.name)) // This is to find out the "name" of the video

                      if (missingInVideo2.length) {
                        setRemovedVideoNames((prev) => [...prev, missingInVideo2[0]?.name]) // to send at backend
                      }

                      onLevelDataChange({ level: el.level, videos: fileList })
                    }}
                    fileList={el.videos}
                    accept="image/jpeg,image/jpg,image/png,video/mp4,video/quicktime,video/webm"
                  >
                    <Button type="text" icon={<UploadOutlined />}>
                      Click to upload or drag here
                    </Button>
                  </Upload.Dragger>
                  <span>Mandatory Goals</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Mandatory Goals"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, mandatoryGoals: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.mandatoryGoals?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'goals')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  {/* <p>{JSON.stringify(form)}</p> */}
                  {el.mandatoryGoals.map((goal, idx) => {
                    const matchedItem = focusItems.find((item) => item._id === goal._id)
                    // console.log(matchedItem)
                    if (matchedItem) {
                      return (
                        <div key={idx} style={{ border: '1px solid #c4c4c4', padding: 5 }}>
                          <p style={{ fontWeight: 'bold' }}>Goal: {matchedItem.subTitle}</p>
                          <RenderList
                            title="Mandatory Priorities"
                            dataCategory="priorities"
                            // data={matchedItem.habitsPriorities.filter((item) => {
                            //   // Find the goal object in mandatoryGoals
                            //   const goalObj = el.mandatoryGoals.find((theGoal) => theGoal._id === goal._id)
                            //   // Get the allowed array (e.g., mandatoryPriorities)
                            //   const allowedIds = goalObj?.mandatoryPriorities?.map((o) => o) || []
                            //   // Include only if the item's _id is in allowedIds
                            //   return allowedIds.includes(item._id)
                            // })}
                            data={(() => {
                              const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.mandatoryPriorities || []

                              // 1. Already present in matchedItem.habitsPriorities
                              const foundItems = matchedItem.habitsPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryPriorities',
                              key: 'mandatoryGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Priorities"
                            dataCategory="priorities"
                            // TODO: Old version keep for next few days until this feature is completely done
                            // data={matchedItem.optionalPriorities.filter((item) => {
                            //   const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                            //   const allowedIds = goalObj?.optionalPriorities?.map((o) => o) || []
                            //   return allowedIds.includes(item._id)
                            // })}
                            data={(() => {
                              const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.optionalPriorities || []

                              // 1. Already present in matchedItem.optionalPriorities
                              const foundItems = matchedItem.optionalPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalPriorities',
                              key: 'mandatoryGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Mandatory Habits"
                            dataCategory="habits"
                            // data={matchedItem.mandatoryHabits.filter((item) => {
                            //   const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                            //   const allowedIds = goalObj?.mandatoryHabits?.map((o) => o) || []
                            //   return allowedIds.includes(item._id)
                            // })}
                            data={(() => {
                              const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.mandatoryHabits || []

                              // 1. Already present in matchedItem.mandatoryHabits
                              const foundItems = matchedItem.mandatoryHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryHabits',
                              key: 'mandatoryGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Habits"
                            dataCategory="habits"
                            // data={matchedItem.optionalHabits.filter((item) => {
                            //   const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                            //   const allowedIds = goalObj?.optionalHabits?.map((o) => o) || []
                            //   return allowedIds.includes(item._id)
                            // })}
                            data={(() => {
                              const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.optionalHabits || []

                              // 1. Already present in matchedItem.optionalHabits
                              const foundItems = matchedItem.optionalHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalHabits',
                              key: 'mandatoryGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Mandatory Challenges"
                            dataCategory="challenges"
                            // data={matchedItem.mandatoryChallenges.filter((item) => {
                            //   const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                            //   const allowedIds = goalObj?.mandatoryChallenges?.map((o) => o) || []
                            //   return allowedIds.includes(item._id)
                            // })}
                            data={(() => {
                              const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.mandatoryChallenges || []

                              // 1. Already present in matchedItem.mandatoryChallenges
                              const foundItems = matchedItem.mandatoryChallenges.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryChallenges',
                              key: 'mandatoryGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Challenges"
                            dataCategory="challenges"
                            // data={matchedItem.optionalChallenges.filter((item) => {
                            //   const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                            //   const allowedIds = goalObj?.optionalChallenges?.map((o) => o) || []
                            //   return allowedIds.includes(item._id)
                            // })}
                            data={(() => {
                              const goalObj = el.mandatoryGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.optionalChallenges || []

                              // 1. Already present in matchedItem.optionalChallenges
                              const foundItems = matchedItem.optionalChallenges.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalChallenges',
                              key: 'mandatoryGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                        </div>
                      )
                    } else {
                      return ''
                    }
                  })}

                  <span>Optional Goals</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Optional Goals"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, optionalGoals: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.optionalGoals?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'goals')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  {el.optionalGoals.map((goal, idx) => {
                    const matchedItem = focusItems.find((item) => item._id === goal._id)
                    if (matchedItem) {
                      return (
                        <div key={idx} style={{ border: '1px solid #c4c4c4', padding: 5 }}>
                          <p style={{ fontWeight: 'bold' }}>Goal: {matchedItem.subTitle}</p>
                          <RenderList
                            title="Mandatory Priorities"
                            dataCategory="priorities"
                            data={(() => {
                              const goalObj = el.optionalGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.mandatoryPriorities || []

                              // 1. Already present in matchedItem.habitsPriorities
                              const foundItems = matchedItem.habitsPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryPriorities',
                              key: 'optionalGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Priorities"
                            dataCategory="priorities"
                            data={(() => {
                              const goalObj = el.optionalGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.optionalPriorities || []

                              // 1. Already present in matchedItem.optionalPriorities
                              const foundItems = matchedItem.optionalPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalPriorities',
                              key: 'optionalGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Mandatory Habits"
                            dataCategory="habits"
                            data={(() => {
                              const goalObj = el.optionalGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.mandatoryHabits || []

                              // 1. Already present in matchedItem.mandatoryHabits
                              const foundItems = matchedItem.mandatoryHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryHabits',
                              key: 'optionalGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Habits"
                            dataCategory="habits"
                            data={(() => {
                              const goalObj = el.optionalGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.optionalHabits || []

                              // 1. Already present in matchedItem.optionalHabits
                              const foundItems = matchedItem.optionalHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalHabits',
                              key: 'optionalGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Mandatory Challenges"
                            dataCategory="challenges"
                            data={(() => {
                              const goalObj = el.optionalGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.mandatoryChallenges || []

                              // 1. Already present in matchedItem.mandatoryChallenges
                              const foundItems = matchedItem.mandatoryChallenges.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryChallenges',
                              key: 'optionalGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Challenges"
                            dataCategory="challenges"
                            data={(() => {
                              const goalObj = el.optionalGoals.find((theElement) => theElement._id === goal._id)
                              const allowedIds = goalObj?.optionalChallenges || []

                              // 1. Already present in matchedItem.optionalChallenges
                              const foundItems = matchedItem.optionalChallenges.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalChallenges',
                              key: 'optionalGoals', // Under there the type item will be removed
                              keyId: goal._id,
                              level: el.level,
                            }}
                          />
                        </div>
                      )
                    } else {
                      return ''
                    }
                  })}
                  <span>Mandatory challenges</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Mandatory challenges"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, mandatoryChallenges: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.mandatoryChallenges?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'challenges')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  {el.mandatoryChallenges.map((challenge, idx) => {
                    const matchedItem = focusItems.find((item) => item._id === challenge._id)
                    if (matchedItem) {
                      return (
                        <div key={idx} style={{ border: '1px solid #c4c4c4', padding: 5 }}>
                          <p style={{ fontWeight: 'bold' }}>Challenge: {matchedItem.subTitle}</p>
                          <RenderList
                            title="Mandatory Priorities"
                            dataCategory="priorities"
                            data={(() => {
                              const goalObj = el.mandatoryChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.mandatoryPriorities || []

                              // 1. Already present in matchedItem.habitsPriorities
                              const foundItems = matchedItem.habitsPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryPriorities',
                              key: 'mandatoryChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Priorities"
                            dataCategory="priorities"
                            data={(() => {
                              const goalObj = el.mandatoryChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.optionalPriorities || []

                              // 1. Already present in matchedItem.optionalPriorities
                              const foundItems = matchedItem.optionalPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalPriorities',
                              key: 'mandatoryChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Mandatory Habits"
                            dataCategory="habits"
                            data={(() => {
                              const goalObj = el.mandatoryChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.mandatoryHabits || []

                              // 1. Already present in matchedItem.mandatoryHabits
                              const foundItems = matchedItem.mandatoryHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryHabits',
                              key: 'mandatoryChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Habits"
                            dataCategory="habits"
                            data={(() => {
                              const goalObj = el.mandatoryChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.optionalHabits || []

                              // 1. Already present in matchedItem.optionalHabits
                              const foundItems = matchedItem.optionalHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalHabits',
                              key: 'mandatoryChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                        </div>
                      )
                    } else {
                      return ''
                    }
                  })}
                  <span>Optional challenges</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Optional challenges"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, optionalChallenges: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.optionalChallenges?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'challenges')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  {el.optionalChallenges.map((challenge, idx) => {
                    const matchedItem = focusItems.find((item) => item._id === challenge._id)
                    if (matchedItem) {
                      return (
                        <div key={idx} style={{ border: '1px solid #c4c4c4', padding: 5 }}>
                          <p style={{ fontWeight: 'bold' }}>Challenge: {matchedItem.subTitle}</p>
                          <RenderList
                            title="Mandatory Priorities"
                            dataCategory="priorities"
                            data={(() => {
                              const goalObj = el.optionalChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.mandatoryPriorities || []

                              // 1. Already present in matchedItem.habitsPriorities
                              const foundItems = matchedItem.habitsPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryPriorities',
                              key: 'optionalChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Priorities"
                            dataCategory="priorities"
                            data={(() => {
                              const goalObj = el.optionalChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.optionalPriorities || []

                              // 1. Already present in matchedItem.optionalPriorities
                              const foundItems = matchedItem.optionalPriorities.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalPriorities',
                              key: 'optionalChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Mandatory Habits"
                            dataCategory="habits"
                            data={(() => {
                              const goalObj = el.optionalChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.mandatoryHabits || []

                              // 1. Already present in matchedItem.mandatoryHabits
                              const foundItems = matchedItem.mandatoryHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'mandatoryHabits',
                              key: 'optionalChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                          <RenderList
                            title="Optional Habits"
                            dataCategory="habits"
                            data={(() => {
                              const goalObj = el.optionalChallenges.find((theElement) => theElement._id === challenge._id)
                              const allowedIds = goalObj?.optionalHabits || []

                              // 1. Already present in matchedItem.optionalHabits
                              const foundItems = matchedItem.optionalHabits.filter((item) => allowedIds.includes(item._id))

                              // 2. Missing ones (lookup from focusItems + add property), Which is added by the admin
                              const missingItems = allowedIds
                                .filter((id) => !foundItems.some((fi) => fi._id === id))
                                .map((id) => {
                                  const obj = focusItems.find((fi) => fi._id === id)
                                  return obj ? { ...obj, isMissing: true } : null
                                })
                                .filter(Boolean)

                              // 3. Merge both
                              return [...foundItems, ...missingItems]
                            })()}
                            onDelete={{
                              type: 'optionalHabits',
                              key: 'optionalChallenges', // Under there the type item will be removed
                              keyId: challenge._id,
                              level: el.level,
                            }}
                          />
                        </div>
                      )
                    } else {
                      return ''
                    }
                  })}
                  <span>Mandatory habits</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Mandatory habits"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, mandatoryHabits: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.mandatoryHabits?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'habits')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  <span>Optional habits</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Choose optional habits"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, optionalHabits: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.optionalHabits?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'habits')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  <span>Mandatory priorities</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Mandatory priorities"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, mandatoryPriorities: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.mandatoryPriorities?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'priorities')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                  <span>Optional priorities</span>
                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    placeholder="Optional priorities"
                    style={{
                      width: `100%`,
                    }}
                    onChange={(value) => onLevelDataChange({ level: el.level, optionalPriorities: value })}
                    defaultValue={focusItems
                      ?.filter((elTwo) => el.optionalPriorities?.some((item) => item._id === elTwo._id))
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                    options={focusItems
                      .filter((el) => el.category == 'priorities')
                      .map((el) => {
                        return {
                          label: el.subTitle,
                          value: el._id,
                        }
                      })}
                  />
                </Space>
              </div>
            )
          })}

          {loading && <Spin size="large" />}
          <Button
            type="primary"
            disabled={loading}
            onClick={() => {
              if (!stackId) {
                createFocusStack()
              } else {
                editFocusStack()
              }
            }}
          >
            {!stackId ? 'Create now' : 'Save edit'}
          </Button>
        </Space>
      ) : (
        <Spin size="large" />
      )}
    </Layout>
  )
}

export default CreateStack
